import React from 'react'
import PageTitle from '../components/PageTitle'
import UpdateProductForm from '../components/UpdateProductForm'

export default props => (
  <>
    <PageTitle title="Update product" />
    <UpdateProductForm productId={props.match.params.id} />
  </>
)